import React, { createContext, useReducer, Suspense, useContext } from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'components/common/Elements/Elements';

import { contentInitState } from './initialStates';
import contentReducer from './reducers/contentReducer';

const ContentStateContext = createContext();

function ContentProvider({ children }) {
  const [contentState, contentDispatch] = useReducer(
    contentReducer,
    contentInitState
  );

  return (
    <Suspense fallback={<Loading />}>
      <ContentStateContext.Provider
        value={{
          contentState,
          contentDispatch
        }}
      >
        {children}
      </ContentStateContext.Provider>
    </Suspense>
  );
}

function useContent() {
  const context = useContext(ContentStateContext);
  if (context === undefined) {
    throw new Error('useContentState must be used within a AuthProvider');
  }
  return context;
}

ContentProvider.propTypes = {
  children: PropTypes.node
};

export { ContentProvider, useContent, ContentStateContext };
